/* THE EDIT — theme.js v3 · nav, veil, letters, parallax, reveals, rituals */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* page fade-in */
  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('is-loaded');
  });

  /* NAV — invert over the surface directly beneath the header */
  var navEl = document.querySelector('[data-te-nav]');
  var updateNavTheme = function () {
    if (!navEl) return;
    var y = Math.max(26, Math.min(56, navEl.offsetHeight / 2));
    var dark = false;
    var hero = document.querySelector('[data-hero]');
    if (document.body.classList.contains('te-home-template') && hero) {
      var heroRect = hero.getBoundingClientRect();
      if (heroRect.top <= y && heroRect.bottom > y) dark = true;
    }
    var surfaces = Array.prototype.slice.call(document.querySelectorAll('[data-dark],[data-header-theme],[data-curtain]'));
    surfaces.some(function (surface) {
      var rect = surface.getBoundingClientRect();
      if (rect.top > y || rect.bottom <= y) return false;
      if (surface.hasAttribute('data-curtain')) {
        dark = false;
      } else {
        dark = surface.getAttribute('data-header-theme') === 'dark' || surface.hasAttribute('data-dark');
      }
      return true;
    });
    navEl.classList.toggle('is-light', dark);
  };
  updateNavTheme();
  window.addEventListener('scroll', updateNavTheme, { passive: true });
  window.addEventListener('resize', updateNavTheme);

  /* NAV — hide on scroll down, show on scroll up */
  var lastY = window.scrollY, navTick = false;
  window.addEventListener('scroll', function () {
    if (navTick) return;
    navTick = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      if (navEl && !document.body.classList.contains('te-menu-open')) {
        var curtain = document.querySelector('[data-curtain]');
        var curtainActive = false;
        if (curtain) {
          var curtainRect = curtain.getBoundingClientRect();
          curtainActive = curtainRect.top <= 64 && curtainRect.bottom > 64;
        }
        if (!curtainActive && y > lastY && y > 120) navEl.classList.add('is-hidden');
        else navEl.classList.remove('is-hidden');
      }
      lastY = y; navTick = false;
    });
  }, { passive: true });

  /* FULL-SCREEN MENU */
  var mbtn = document.querySelector('[data-te-menubtn]');
  var overlay = document.querySelector('[data-te-overlay]');
  if (mbtn && overlay) {
    overlay.hidden = false;
    var setMenu = function (open) {
      document.body.classList.toggle('te-menu-open', open);
      mbtn.setAttribute('aria-expanded', String(open));
      if (open && navEl) navEl.classList.remove('is-hidden');
    };
    mbtn.addEventListener('click', function () {
      setMenu(!document.body.classList.contains('te-menu-open'));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    overlay.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
  }

  /* HERO — veil retracts on load */
  var hero = document.querySelector('[data-hero]');
  var veil = document.querySelector('[data-veil]');
  function fireHero() {
    if (veil && !reduced) veil.classList.add('off');
    if (hero) hero.classList.add('on');
  }
  if (document.readyState === 'complete') fireHero();
  else window.addEventListener('load', fireHero);

  /* SHARED OBSERVER */
  function observe(sel, cls, th) {
    var els = document.querySelectorAll(sel);
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add(cls); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add(cls); io.unobserve(e.target); }
      });
    }, { threshold: th });
    els.forEach(function (el) { io.observe(el); });
  }
  observe('.te-reveal', 'is-in', 0.12);
  observe('[data-letters]', 'in', 0.4);
  observe('[data-field]', 'open', 0.2);
  observe('[data-cell]', 'in', 0.15);

  /* WHO — slow parallax */
  var pS = document.querySelector('[data-parallax-section]');
  var pT = document.querySelector('[data-parallax]');
  if (pS && pT && !reduced) {
    var pTick = false;
    var run = function () {
      var r = pS.getBoundingClientRect(), vh = window.innerHeight;
      if (r.top < vh && r.bottom > 0) {
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        pT.style.transform = 'translateY(' + (p * -34).toFixed(1) + 'px)';
      }
      pTick = false;
    };
    window.addEventListener('scroll', function () {
      if (!pTick) { requestAnimationFrame(run); pTick = true; }
    }, { passive: true });
    run();
  }

  /* CHAPTER PROGRESS ritual */
  var prog = document.querySelector('[data-te-progress]');
  if (prog) {
    var key = 'te:read:' + (prog.getAttribute('data-key') || location.pathname);
    var check = prog.querySelector('[data-te-check]');
    var fill = prog.querySelector('.te-progress__fill');
    var render = function (read) {
      prog.classList.toggle('is-read', read);
      if (check) { check.classList.toggle('is-read', read); check.setAttribute('aria-pressed', String(read)); }
      if (fill) fill.style.width = read ? '100%' : '0%';
    };
    var stored = false;
    try { stored = localStorage.getItem(key) === '1'; } catch (e) {}
    render(stored);
    if (check) check.addEventListener('click', function () {
      var next = !check.classList.contains('is-read');
      try { next ? localStorage.setItem(key, '1') : localStorage.removeItem(key); } catch (e) {}
      render(next);
      if (next) {
        document.dispatchEvent(new CustomEvent('te:reading-refine', {
          detail: { field: 'auto', score: 3, source: 'chapter:' + key }
        }));
      }
    });
  }

  /* SERIES INDEX — completed states */
  document.querySelectorAll('[data-te-chapter-link]').forEach(function (row) {
    var href = row.getAttribute('data-te-chapter-link') || '';
    var handle = href.split('/').filter(Boolean).pop() || href;
    var done = false;
    try { done = localStorage.getItem('te:read:' + handle) === '1'; } catch (e) {}
    if (done) row.classList.add('is-done');
    var sq = document.querySelector('[data-te-sq="' + handle + '"]');
    if (sq && done) sq.classList.add('is-placed');
  });

  /* QUESTIONNAIRE */
  var quiz = document.querySelector('[data-te-quiz]');
  if (quiz) {
    var steps = quiz.querySelectorAll('.te-quiz__step');
    var score = { a: 0, b: 0, c: 0 }, qi = 0;
    var show = function (i) { steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); }); };
    quiz.querySelectorAll('.te-quiz__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-v');
        if (score[v] !== undefined) score[v]++;
        qi++;
        if (qi < steps.length - 1) show(qi);
        else {
          var top = 'a';
          if (score.b > score[top]) top = 'b';
          if (score.c > score[top]) top = 'c';
          quiz.querySelectorAll('[data-te-result]').forEach(function (r) { r.hidden = true; });
          var res = quiz.querySelector('[data-te-result="' + top + '"]');
          if (res) res.hidden = false;
          show(steps.length - 1);
        }
      });
    });
    show(0);
  }

  /* STATEMENT — wipe reveal */
  observe('[data-wipe]', 'in', 0.4);

  /* CURTAIN — panels split from center */
  var crt = document.querySelector('[data-curtain]');
  var crtL = document.querySelector('[data-crt-l]');
  var crtR = document.querySelector('[data-crt-r]');
  var crtT = document.querySelector('[data-crt-text]');
  if (crt && crtL && crtR && !reduced) {
    var cTick = false;
    var runCrt = function () {
      var r = crt.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = r.height - vh;
      var p = Math.min(1, Math.max(0, -r.top / total));
      crtL.style.transform = 'translateX(' + (-p * 101) + '%)';
      crtR.style.transform = 'translateX(' + (p * 101) + '%)';
      if (crtT) crtT.style.opacity = String(Math.max(0, 1 - p * 2.2));
      updateNavTheme();
      cTick = false;
    };
    window.addEventListener('scroll', function () {
      if (!cTick) { requestAnimationFrame(runCrt); cTick = true; }
    }, { passive: true });
    runCrt();
  } else if (crt && reduced) {
    var v = crt.querySelector('.crt__veil'); if (v) v.style.display = 'none';
  }

  var activeModal = null;
  var modalReturnFocus = null;

  function openModal(name) {
    var m = document.querySelector('[data-te-modal="' + name + '"]');
    if (!m) return;
    if (activeModal && activeModal !== m) {
      activeModal.classList.remove('is-open');
      activeModal.hidden = true;
    }
    if (name === 'reading' && window.TheEditReadingProfile) window.TheEditReadingProfile.prepare();
    modalReturnFocus = document.activeElement;
    activeModal = m;
    m.hidden = false;
    requestAnimationFrame(function () {
      m.classList.add('is-open');
      if (name === 'gate') {
        var activeStep = m.querySelector('.rdm__step.is-active');
        var focusTarget = activeStep ? activeStep.querySelector('input,button,a') : m.querySelector('input,button,a');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }
    });
    if (name === 'gate') document.body.classList.add('te-locked');
  }

  function closeModal(m) {
    if (!m) return;
    var name = m.getAttribute('data-te-modal');
    if (name === 'letter') {
      try { localStorage.setItem('te:letter-dismissed-at', String(Date.now())); } catch (e) {}
    }
    if (name === 'reading') {
      try { sessionStorage.setItem('te:reading-arrival', '1'); } catch (e) {}
    }
    m.classList.remove('is-open');
    document.body.classList.remove('te-locked');
    activeModal = null;
    setTimeout(function () { m.hidden = true; }, 600);
    if (modalReturnFocus && modalReturnFocus.focus) modalReturnFocus.focus({ preventScroll: true });
  }

  document.querySelectorAll('[data-te-modal-close]').forEach(function (b) {
    b.addEventListener('click', function () { closeModal(b.closest('.te-modal')); });
  });
  document.querySelectorAll('.te-modal').forEach(function (m) {
    m.addEventListener('click', function (e) {
      if (e.target === m && m.getAttribute('data-te-modal') !== 'gate') closeModal(m);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeModal && activeModal.getAttribute('data-te-modal') !== 'gate') closeModal(activeModal);
  });

  var readingModal = document.querySelector('[data-te-modal="reading"]');
  var profileChip = document.querySelector('[data-te-profile-chip]');
  var readingHandles = [
    'chapter-i', 'chapter-ii', 'chapter-iii', 'chapter-iv', 'chapter-v',
    'the-grammar-of-taste-part-i', 'copy-of-the-grammar-of-taste-part-ii', 'the-grammar-of-taste-part-iii', 'the-grammar-of-taste-part-iv', 'the-grammar-of-taste-part-v',
    'the-discipline-of-energy-part-i-1', 'the-discipline-of-energy-part-ii', 'the-discipline-of-energy-part-iii', 'the-discipline-of-energy-part-iv', 'the-discipline-of-energy-part-v'
  ];

  function parseStored(keyName, fallback) {
    try {
      var value = localStorage.getItem(keyName);
      return value ? JSON.parse(value) : fallback;
    } catch (e) { return fallback; }
  }

  function storeReading(state) {
    try { localStorage.setItem('te:reading', JSON.stringify(state)); } catch (e) {}
  }

  function readCount() {
    var count = 0;
    readingHandles.forEach(function (handle) {
      try { if (localStorage.getItem('te:read:' + handle) === '1') count += 1; } catch (e) {}
    });
    return count;
  }

  function inferField() {
    var source = location.pathname.toLowerCase();
    var eyebrow = document.querySelector('[data-te-ns] .te-chapter-hero .te-eyebrow');
    if (eyebrow) source += ' ' + eyebrow.textContent.toLowerCase();
    if (/wisdom|grammar|taste/.test(source)) return 'wisdom';
    if (/wellness|discipline|energy/.test(source)) return 'wellness';
    return 'wealth';
  }

  function replaceTokens(template, values) {
    var output = template || '';
    Object.keys(values).forEach(function (keyName) {
      output = output.split('[[' + keyName + ']]').join(values[keyName]);
    });
    return output;
  }

  function profileData(state) {
    var fields = ['wealth', 'wisdom', 'wellness'];
    var totals = { wealth: 1, wisdom: 1, wellness: 1 };
    var base = state.baseScores || state.scores || {};
    fields.forEach(function (field) { totals[field] += parseInt(base[field] || 0, 10); });
    var refinements = state.refinements || {};
    Object.keys(refinements).forEach(function (source) {
      var entry = refinements[source];
      if (entry && totals[entry.field] !== undefined) totals[entry.field] += parseInt(entry.score || 0, 10);
    });
    var total = totals.wealth + totals.wisdom + totals.wellness;
    var percentages = {};
    var assigned = 0;
    fields.forEach(function (field, index) {
      var percentage = index === fields.length - 1 ? 100 - assigned : Math.round(totals[field] / total * 100);
      percentages[field] = percentage;
      assigned += percentage;
    });
    var ranked = fields.slice().sort(function (a, b) { return totals[b] - totals[a]; });
    var leading = ranked[0];
    var next = ranked[ranked.length - 1];
    var spread = percentages[leading] - percentages[next];
    var completedReadings = readCount();
    var profile = 'architect';
    if (completedReadings >= readingHandles.length) profile = 'sovereign';
    else if (spread <= 8) profile = 'architect';
    else if (leading === 'wealth') profile = 'strategist';
    else if (leading === 'wisdom' && totals.wellness >= totals.wealth * 0.85) profile = 'dreamer';
    else if (leading === 'wisdom') profile = 'curator';
    else profile = 'conductor';
    return {
      totals: totals,
      percentages: percentages,
      leading: leading,
      next: next,
      profile: profile,
      read: completedReadings,
      answers: Object.keys(refinements).filter(function (source) { return source.indexOf('chapter:') !== 0; }).length
    };
  }

  function profileCopy(profile) {
    return readingModal ? readingModal.querySelector('[data-rdm-profile="' + profile + '"]') : null;
  }

  function roomLabel(field) {
    return readingModal ? readingModal.getAttribute('data-room-' + field) : field;
  }

  function showReadingStep(name) {
    if (!readingModal) return;
    readingModal.querySelectorAll('[data-rdm-step]').forEach(function (step) {
      step.classList.toggle('is-active', step.getAttribute('data-rdm-step') === name);
    });
    var panel = readingModal.querySelector('.te-modal__panel');
    if (panel) panel.scrollTop = 0;
  }

  function renderReadingProfile(state) {
    if (!readingModal || !state || !state.completed) return;
    var data = profileData(state);
    var copy = profileCopy(data.profile);
    var profileTitle = copy ? copy.getAttribute('data-title') : '';
    var namePrefix = state.name ? state.name + ', ' : '';
    var title = readingModal.querySelector('[data-rdm-title]');
    var strength = readingModal.querySelector('[data-rdm-strength]');
    var shadow = readingModal.querySelector('[data-rdm-shadow]');
    var progress = readingModal.querySelector('[data-rdm-progress]');
    var verdict = readingModal.querySelector('[data-rdm-verdict]');
    var stage = readingModal.querySelector('[data-rdm-stage]');
    var begin = readingModal.querySelector('[data-rdm-begin]');
    if (title) title.textContent = replaceTokens(readingModal.getAttribute('data-rdm-title-template'), { name: namePrefix, profile: profileTitle });
    if (strength) strength.textContent = copy ? copy.getAttribute('data-strength') : '';
    if (shadow) shadow.textContent = copy ? copy.getAttribute('data-shadow') : '';
    if (progress) progress.textContent = replaceTokens(readingModal.getAttribute('data-rdm-progress-template'), { read: data.read, answers: data.answers });
    if (verdict) verdict.textContent = replaceTokens(readingModal.getAttribute('data-rdm-verdict-template'), { leading: roomLabel(data.leading), next: roomLabel(data.next) });
    if (stage) {
      if (data.profile === 'sovereign') stage.textContent = readingModal.getAttribute('data-rdm-stage-integrated');
      else if (data.read || data.answers) stage.textContent = readingModal.getAttribute('data-rdm-stage-evolving');
      else stage.textContent = readingModal.getAttribute('data-rdm-stage-initial');
    }
    var urls = { wealth: '/pages/the-architecture-of-wealth', wisdom: '/pages/the-grammar-of-taste', wellness: '/pages/the-discipline-of-energy-part-i' };
    if (begin) {
      begin.setAttribute('href', urls[data.next]);
      begin.textContent = replaceTokens(readingModal.getAttribute('data-rdm-room-template'), { room: roomLabel(data.next) });
    }
    ['wealth', 'wisdom', 'wellness'].forEach(function (field) {
      var bar = readingModal.querySelector('[data-rdm-bar="' + field + '"]');
      var value = readingModal.querySelector('[data-rdm-val="' + field + '"]');
      if (bar) requestAnimationFrame(function () { bar.style.width = data.percentages[field] + '%'; });
      if (value) value.textContent = data.percentages[field] + '%';
    });
    state.percentages = data.percentages;
    state.profile = profileTitle;
    state.profileKey = data.profile;
    state.leadingRoom = data.leading;
    state.nextRoom = data.next;
    state.readCount = data.read;
    state.updatedAt = Date.now();
    storeReading(state);
    if (profileChip) {
      profileChip.hidden = false;
      var chipName = profileChip.querySelector('[data-te-profile-chip-name]');
      if (chipName) chipName.textContent = profileTitle;
    }
  }

  var readingQuizScores = { wealth: 0, wisdom: 0, wellness: 0 };
  var readingAnswers = [];
  var readingQuestionIndex = 0;
  var readingQuestionNames = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'];

  function resetReadingQuiz() {
    readingQuizScores = { wealth: 0, wisdom: 0, wellness: 0 };
    readingAnswers = [];
    readingQuestionIndex = 0;
    showReadingStep('intro');
  }

  if (readingModal) {
    var startReading = readingModal.querySelector('[data-rdm-start]');
    var readingName = readingModal.querySelector('[data-rdm-name]');
    if (startReading) startReading.addEventListener('click', function () {
      readingQuestionIndex = 0;
      showReadingStep(readingQuestionNames[0]);
    });
    if (readingName) readingName.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); startReading.click(); }
    });
    readingModal.querySelectorAll('[data-rdm-answer]').forEach(function (answer) {
      answer.addEventListener('click', function () {
        var field = answer.getAttribute('data-field');
        var score = parseInt(answer.getAttribute('data-score'), 10) || 1;
        readingQuizScores[field] += score;
        readingAnswers.push({ field: field, score: score, answer: answer.textContent.trim() });
        readingQuestionIndex += 1;
        if (readingQuestionIndex < readingQuestionNames.length) {
          showReadingStep(readingQuestionNames[readingQuestionIndex]);
        } else {
          var state = parseStored('te:reading', {});
          state.name = readingName ? readingName.value.trim() : '';
          state.baseScores = readingQuizScores;
          state.initialAnswers = readingAnswers;
          state.refinements = state.refinements || {};
          state.completed = true;
          storeReading(state);
          renderReadingProfile(state);
          showReadingStep('result');
        }
      });
    });
    var restartReading = readingModal.querySelector('[data-rdm-restart]');
    if (restartReading) restartReading.addEventListener('click', resetReadingQuiz);
  }

  window.TheEditReadingProfile = {
    prepare: function () {
      var state = parseStored('te:reading', {});
      if (state.completed) {
        renderReadingProfile(state);
        showReadingStep('result');
      } else resetReadingQuiz();
    },
    refine: function (detail) {
      var state = parseStored('te:reading', {});
      if (!state.completed || !detail) return;
      var field = detail.field === 'auto' || !detail.field ? inferField() : detail.field;
      if (['wealth', 'wisdom', 'wellness'].indexOf(field) < 0) field = inferField();
      var score = parseInt(detail.score || 0, 10);
      var payload = detail.payload || {};
      if (!score && typeof payload.choiceIndex === 'number') score = Math.min(3, payload.choiceIndex + 1);
      if (!score && typeof payload.ratio === 'number') score = Math.max(1, Math.min(3, Math.round(1 + payload.ratio * 2)));
      if (!score && payload.entries && payload.entries.length) score = Math.max(1, Math.min(3, Math.ceil(payload.entries.length / 4)));
      if (!score) score = 2;
      state.refinements = state.refinements || {};
      state.refinements[detail.source || ('exercise:' + location.pathname + ':' + Date.now())] = { field: field, score: score };
      storeReading(state);
      renderReadingProfile(state);
    }
  };

  document.addEventListener('te:reading-refine', function (event) {
    window.TheEditReadingProfile.refine(event.detail || {});
  });

  var existingReading = parseStored('te:reading', {});
  if (existingReading.completed) renderReadingProfile(existingReading);
  if (profileChip) profileChip.addEventListener('click', function () { openModal('reading'); });

  document.querySelectorAll('a[href$="#the-reading"],a[href="/pages/the-reading"],a[href="/pages/questionnaire"],a[data-te-reading-gate="true"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      openModal('reading');
    });
  });

  /* PAYWALL — gated chapters */
  var gated = document.querySelector('[data-te-gated]');
  /* Theme editor previews must remain fully inspectable by the merchant. */
  if (gated && !(window.Shopify && window.Shopify.designMode)) {
    var pct = parseInt(gated.getAttribute('data-gate-pct') || '35', 10) / 100;
    var fired = false, gTick = false;
    var runGate = function () {
      if (fired) { gTick = false; return; }
      var r = gated.getBoundingClientRect();
      var read = Math.min(1, Math.max(0, (window.innerHeight - r.top) / r.height));
      if (read > pct) { fired = true; openModal('gate'); }
      gTick = false;
    };
    window.addEventListener('scroll', function () {
      if (!gTick) { requestAnimationFrame(runGate); gTick = true; }
    }, { passive: true });
  }

  /* THE CONSULTATION — multi-step before submit */
  var cs = document.querySelector('[data-consult]');
  if (cs) {
    var cSteps = Array.prototype.slice.call(cs.querySelectorAll('[data-cs-step]'));
    var ci = 0;
    cs.querySelectorAll('[data-cs-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var field = cSteps[ci].querySelector('input,textarea');
        if (field && field.hasAttribute('required') && !field.value.trim()) { field.focus(); return; }
        ci++;
        cSteps.forEach(function (s, n) { s.classList.toggle('is-active', n === ci); });
      });
    });
  }


  document.querySelectorAll('a[href$="#letter"]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); openModal('letter'); });
  });

  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var letterSuccess = document.querySelector('[data-letter-success]');
  if (letterSuccess) {
    try { localStorage.setItem('te:letter-subscribed', '1'); } catch (e) {}
    if (!designMode) setTimeout(function () { openModal('letter'); }, 350);
  }

  function letterEligible() {
    try {
      if (localStorage.getItem('te:letter-subscribed') === '1') return false;
      if (sessionStorage.getItem('te:letter-arrival') === '1') return false;
      var dismissed = parseInt(localStorage.getItem('te:letter-dismissed-at') || '0', 10);
      return !dismissed || Date.now() - dismissed > 7 * 24 * 60 * 60 * 1000;
    } catch (e) { return true; }
  }

  function offerLetter() {
    if (!letterEligible()) return;
    if (activeModal) {
      setTimeout(offerLetter, 6000);
      return;
    }
    try { sessionStorage.setItem('te:letter-arrival', '1'); } catch (e) {}
    openModal('letter');
  }

  if (!designMode && !letterSuccess) {
    var directReading = location.hash === '#the-reading';
    var arrivalShown = false;
    try { arrivalShown = sessionStorage.getItem('te:reading-arrival') === '1'; } catch (e) {}
    if (directReading) {
      try { sessionStorage.setItem('te:reading-arrival', '1'); } catch (e) {}
      setTimeout(function () { openModal('reading'); }, 250);
    } else if (!arrivalShown) {
      var readingArrivalOffered = false;
      var readingArrivalTimer = null;
      var offerReadingArrival = function () {
        if (readingArrivalOffered) return;
        if (activeModal) {
          readingArrivalTimer = setTimeout(offerReadingArrival, 1500);
          return;
        }
        readingArrivalOffered = true;
        window.removeEventListener('scroll', offerReadingArrival);
        if (readingArrivalTimer) clearTimeout(readingArrivalTimer);
        try { sessionStorage.setItem('te:reading-arrival', '1'); } catch (e) {}
        openModal('reading');
      };
      window.addEventListener('scroll', offerReadingArrival, { passive: true, once: true });
      readingArrivalTimer = setTimeout(offerReadingArrival, 6500);
    }
    setTimeout(offerLetter, 22000);
  }

  /* REFLECTIVE options in chapters */
  document.querySelectorAll('[data-ref]').forEach(function (ref) {
    ref.querySelectorAll('.ch-ref__opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        ref.querySelectorAll('.ch-ref__opt').forEach(function (o) { o.classList.remove('is-sel'); });
        opt.classList.add('is-sel');
      });
    });
  });

  /* SERIES chess board — fill squares for read parts */
  document.querySelectorAll('[data-sb-sq]').forEach(function (sq) {
    var href = sq.getAttribute('data-sb-sq') || '';
    var handle = href.split('/').filter(Boolean).pop() || href;
    try { if (localStorage.getItem('te:read:' + handle) === '1') sq.classList.add('is-done'); } catch (e) {}
  });

  var libraryBoard = document.querySelector('[data-library-board]');
  if (libraryBoard) {
    var librarySquares = Array.prototype.slice.call(libraryBoard.querySelectorAll('[data-lb-square]'));
    var libraryProgress = libraryBoard.querySelector('[data-lb-progress]');
    var libraryRoom = libraryBoard.querySelector('[data-lb-room]');
    var libraryTitle = libraryBoard.querySelector('[data-lb-title]');
    var libraryMeta = libraryBoard.querySelector('[data-lb-meta]');
    var libraryState = libraryBoard.querySelector('[data-lb-state]');
    var completed = 0;
    var recommended = '';
    try {
      var savedReading = JSON.parse(localStorage.getItem('te:reading') || '{}');
      recommended = savedReading.nextRoom || '';
    } catch (e) {}
    librarySquares.forEach(function (square) {
      var handle = square.getAttribute('data-handle') || '';
      var done = false;
      try { done = localStorage.getItem('te:read:' + handle) === '1'; } catch (e) {}
      if (done) {
        completed += 1;
        square.classList.add('is-complete');
      }
    });
    if (recommended) {
      var recommendedSquares = librarySquares.filter(function (square) {
        return square.getAttribute('data-room') === recommended && !square.classList.contains('is-complete');
      });
      if (recommendedSquares[0]) recommendedSquares[0].classList.add('is-recommended');
    }
    if (libraryProgress) libraryProgress.textContent = String(completed).padStart(2, '0') + ' / ' + String(librarySquares.length).padStart(2, '0');
    if (libraryState) {
      libraryState.textContent = completed === librarySquares.length
        ? libraryBoard.getAttribute('data-complete-copy')
        : libraryBoard.getAttribute('data-empty-copy');
    }
    var showLibrarySquare = function (square) {
      if (libraryRoom) libraryRoom.textContent = square.getAttribute('data-room-label') + ' · Part ' + square.getAttribute('data-part');
      if (libraryTitle) libraryTitle.textContent = square.getAttribute('data-title');
      if (libraryMeta) libraryMeta.textContent = square.getAttribute('data-meta');
    };
    librarySquares.forEach(function (square) {
      square.addEventListener('mouseenter', function () { showLibrarySquare(square); });
      square.addEventListener('focus', function () { showLibrarySquare(square); });
    });
    if (window.matchMedia('(hover: none)').matches) {
      librarySquares.forEach(function (square) {
        square.setAttribute('aria-expanded', 'false');
        square.addEventListener('click', function (event) {
          if (square.classList.contains('is-touch-preview')) return;
          event.preventDefault();
          librarySquares.forEach(function (other) {
            other.classList.remove('is-touch-preview');
            other.setAttribute('aria-expanded', 'false');
          });
          square.classList.add('is-touch-preview');
          square.setAttribute('aria-expanded', 'true');
          libraryBoard.classList.add('is-touch-previewing');
          showLibrarySquare(square);
        });
      });
      document.addEventListener('click', function (event) {
        if (libraryBoard.contains(event.target)) return;
        librarySquares.forEach(function (square) {
          square.classList.remove('is-touch-preview');
          square.setAttribute('aria-expanded', 'false');
        });
        libraryBoard.classList.remove('is-touch-previewing');
      });
    }
    var initialSquare = libraryBoard.querySelector('.is-recommended') || librarySquares[0];
    if (initialSquare) showLibrarySquare(initialSquare);
  }

})();
